// Mock data for Funny Is My Surname Comedy Website

export const bioData = {
  name: "Paola Matacchioni",
  stageName: "Funny by Surname",
  tagline: "Mattacchioni means 'someone funny and crazy' in Italian. Meant to be.",
  bio: "I'm a London-based comedian bringing laughter in both English and Italian. I've performed at some of the UK's most prestigious comedy venues including two big openings at the Comedy Store, Leicester Square Theatre, and Banana Cabaret. When I'm not on stage, I'm running comedy nights, hosting pub quizzes, and working as a Marketing Tech Lead with 12 years of experience across Meta, Google, Adobe, and Smartsheet. I'm a natural-born entertainer who knows how to bring the fun to any event – from intimate comedy clubs to corporate gatherings.",
  credentials: [
    "2 Big Openings at The Comedy Store",
    "Leicester Square Theatre",
    "Banana Cabaret",
    "Marketing Tech Lead (Meta, Google, Adobe, Smartsheet)",
    "12+ Years in Marketing & Tech"
  ],
  instagramHandle: "@funnybysurname_comedy",
  instagramUrl: "https://www.instagram.com/funnybysurname_comedy/",
  tiktokHandle: "@funnybbysurname",
  tiktokUrl: "https://www.tiktok.com/@funnybbysurname",
  linkedInUrl: "https://www.linkedin.com/in/marketing-paolamatacchioni/?locale=en_US",
  calendlyUrl: "https://calendly.com/app/scheduling/meeting_types/user/me"
};

export const galleryPhotos = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_comedywaves/artifacts/0s8pu0vd_C51AC81F-C15B-4693-B05F-04A137E3EE74.JPG",
    alt: "Paola Matacchioni performing comedy"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_comedywaves/artifacts/k54dwh16_DSC02449.JPG",
    alt: "Paola Matacchioni on stage"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_comedywaves/artifacts/53btp8ok_Photobooth%20Adobe%20EM24%20-%20Paola%201.JPG",
    alt: "Paola Matacchioni at Adobe event"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_comedywaves/artifacts/ve63l87s_IMG_0507.JPG",
    alt: "Paola Matacchioni comedy performance"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_comedywaves/artifacts/9zqguo18_Photobooth%20Adobe%20EM24%20-%20Paola%202.JPG",
    alt: "Paola Matacchioni at Adobe photobooth"
  }
];

export const upcomingShows = [
  {
    id: 1,
    date: "2025-02-12",
    displayDate: "Thursday, 12th February 2025",
    time: "7:30 PM",
    venue: "La Pizzica Restaurant",
    location: "Fulham, London",
    title: "Anti-Valentine's Night",
    role: "MC",
    ticketUrl: "https://www.eventbrite.it/e/anti-valentines-comedy-show-in-fulham-tickets-1981856019705",
    platform: "Eventbrite",
    description: "Join me as MC for a hilarious Anti-Valentine's night at La Pizzica!"
  },
  {
    id: 2,
    date: "2025-02-24",
    displayDate: "Monday, 24th February 2025",
    time: "TBC",
    venue: "Backyard Comedy Club",
    location: "Bethnal Green, London",
    title: "Backyard Comedy",
    role: "Performer",
    ticketUrl: "https://backyardcomedyclub.co.uk/event/link/?ceId=6c05ad02-c074-4f53-ad28-9451d861d3b0",
    platform: "Backyard",
    description: "Catch me live at one of London's best comedy venues!"
  },
  {
    id: 3,
    date: "2025-02-26",
    displayDate: "Wednesday, 26th February 2025",
    time: "TBC",
    venue: "King's Head Theatre",
    location: "Islington, London",
    title: "Downstairs at the King's Head",
    role: "Performer",
    ticketUrl: "https://www.downstairsatthekingshead.com/showevent.aspx?EventID=15516",
    platform: "King's Head",
    description: "An intimate comedy night in the heart of Islington."
  },
  {
    id: 4,
    date: "2025-03-13",
    displayDate: "Thursday, 13th March 2025",
    time: "TBC",
    venue: "Hoxton Cabin",
    location: "Hoxton, London",
    title: "Bitches in Stitches",
    role: "Performer",
    ticketUrl: "https://dice.fm/event/537xn8-bitches-in-stitches-femmesthems-comedy-night-13th-mar-hoxton-cabin-london-tickets?lng=en",
    platform: "Dice",
    description: "FemmesThems comedy night bringing the laughs to Hoxton!"
  }
];

export const videoCategories = [
  {
    id: "english",
    title: "English Comedy",
    description: "Life in London, marketing mishaps, and everything in between",
    videos: [
      {
        id: 1,
        title: "London Life Observations",
        thumbnail: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&q=80",
        platform: "Instagram"
      },
      {
        id: 2,
        title: "Marketing Tech Lead vs Comedian",
        thumbnail: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=800&q=80",
        platform: "Instagram"
      },
      {
        id: 3,
        title: "Corporate Event Highlights",
        thumbnail: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80",
        platform: "Instagram"
      }
    ]
  },
  {
    id: "italian",
    title: "Italian Comedy",
    description: "Commedia italiana per chi vuole ridere in lingua madre",
    videos: [
      {
        id: 4,
        title: "Vita Italiana a Londra",
        thumbnail: "https://images.unsplash.com/photo-1533929736458-ca588d08c8be?w=800&q=80",
        platform: "Instagram"
      },
      {
        id: 5,
        title: "Differenze Culturali",
        thumbnail: "https://images.unsplash.com/photo-1527224857830-43a7acc85260?w=800&q=80",
        platform: "Instagram"
      },
      {
        id: 6,
        title: "Gli Italiani a Londra",
        thumbnail: "https://images.unsplash.com/photo-1541336032412-2048a678540d?w=800&q=80",
        platform: "Instagram"
      }
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Corporate Comedy",
    icon: "briefcase",
    description: "Elevate your corporate events with professional comedy that resonates. Perfect for team building, conferences, and company celebrations.",
    highlights: [
      "Custom material tailored to your company",
      "Professional MC services",
      "12+ years corporate experience"
    ]
  },
  {
    id: 2,
    title: "Comedy Nights",
    icon: "mic",
    description: "Book me for your comedy club or private event. Experienced in both English and Italian performances across London's top venues.",
    highlights: [
      "English & Italian performances",
      "MC or performer roles",
      "Proven track record at top venues"
    ]
  },
  {
    id: 3,
    title: "Pub Quizzes",
    icon: "brain",
    description: "Looking for a fun, engaging quiz host? I bring energy, humor, and 12 years of tech knowledge to create unforgettable quiz nights.",
    highlights: [
      "Entertaining hosting style",
      "Custom quiz topics available",
      "Perfect for team socials"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Comedy Store Attendee",
    role: "Audience Member",
    quote: "Absolutely hilarious! The energy and timing were perfect. Can't wait to see more shows!"
  },
  {
    id: 2,
    name: "Corporate Event Organizer",
    role: "Events Manager",
    quote: "Professional, funny, and perfectly pitched for our corporate audience. Would book again in a heartbeat."
  },
  {
    id: 3,
    name: "Italian Comedy Fan",
    role: "London Italian Community",
    quote: "Finalmente commedia italiana di qualità a Londra! Brilliant performance!"
  }
];
